import Tooltip, { TooltipDirection, TooltipSize } from 'lib/Tooltip';
import Button, { Color } from 'lib/Button';
import plusSvg from 'assets/icons/plus.svg';
import minusSvg from 'assets/icons/minus.svg';

interface ZoomControlsProps {
  zoom: number;
  updateMapZoom: (zoom: number) => void;
}

const ZoomControls: React.FC<ZoomControlsProps> = ({ zoom, updateMapZoom }) => (
  <div className="w-12 h-fit p-1 flex flex-col gap-2 shadow-sm border border-neutral-300 rounded-md bg-white items-center">
    <Tooltip tooltip="Zoom in" contentSize={TooltipSize.MAX} direction={TooltipDirection.RIGHT}>
      <Button
        dataTestId="zoom-in-button"
        svg={plusSvg}
        color={Color.TRANSPARENT}
        classNames="w-10 h-8"
        svgClassnames="text-neutral-900"
        onClick={() => updateMapZoom(zoom + 1)}
      />
    </Tooltip>
    <Tooltip tooltip="Zoom out" contentSize={TooltipSize.MAX} direction={TooltipDirection.RIGHT}>
      <Button
        dataTestId="zoom-out-button"
        svg={minusSvg}
        color={Color.TRANSPARENT}
        classNames="w-10 h-8"
        svgClassnames="text-neutral-900"
        onClick={() => updateMapZoom(zoom - 1)}
      />
    </Tooltip>
  </div>
);

export default ZoomControls;
